import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'iw-reports-structure-operactions',
  templateUrl: './reports-structure-operactions.component.html',
  styleUrls: ['./reports-structure-operactions.component.scss']
})
export class ReportsStructureOperactionsComponent implements OnInit {

  // Contiene la operacion de la columna
  @Input() operation: any = null;
  // Variable que contendrá el formulario de generar radicado.
  form: FormGroup = new FormGroup({
    operacion: new FormControl(null),
  });
  // Emite la operacion de la columna
  @Output() finalOperation: EventEmitter<string> = new EventEmitter();

  constructor() { }

  ngOnInit() {
    if (this.operation) {
      this.form.controls['operacion'].setValue(this.operation['operacion']);
    }
    this.form.valueChanges.subscribe(data => this.finalOperation.emit(data));
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-reports/reports/reports-structure/reports-structure-operactions/reports-structure-operactions.component.ts